import type { UnsubscriptionFlowStages } from '../enums/unsubscriptionFlowStages';
import eventsSubscriptionNames from '../events/subscription';
import { useSendEvent } from '../useSendEvent';

const useViewModalPremiumActive = () =>
	useSendEvent(eventsSubscriptionNames.viewModalPremiumActive);

const useClickButtonShareFeedback = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonShareFeedback);

const useClickButtonSubmitFeedback = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonSubmitFeedback);

const useClickButtonCancelRenewalFirst = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonCancelRenewalFirst);

const useClickButtonKeepBenefitsCancelSub = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonKeepBenefitsCancelSub);

const useClickButtonImSureCancelSub = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonImSureCancelSub);

const useViewModalUnsubscriptionOffer = () =>
	useSendEvent(eventsSubscriptionNames.viewModalUnsubscriptionOffer);

const useClickButtonDeclineUnsubscriptionOffer = ({
	discount,
}: {
	discount: number;
}) =>
	useSendEvent(eventsSubscriptionNames.clickButtonDeclineUnsubscriptionOffer, {
		discount_perc: discount,
	});

const useClickButtonAcceptUnsubscriptionOffer = ({
	discount,
}: {
	discount: number;
}) =>
	useSendEvent(eventsSubscriptionNames.clickButtonAcceptUnsubscriptionOffer, {
		discount_perc: discount,
	});

const useClickButtonCancelCancelSub = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonCancelCancelSub);

const useClickButtonNotNowCancelSub = () =>
	useSendEvent(eventsSubscriptionNames.clickButtonNotNowCancelSub);

const useViewModalCanceledPremiumCancelSub = () =>
	useSendEvent(eventsSubscriptionNames.viewModalCanceledPremiumCancelSub);

const useClickButtonRestoreSubscription = ({
	discount,
}: {
	discount: number;
}) =>
	useSendEvent(eventsSubscriptionNames.clickButtonRestoreSubscription, {
		discount_perc: discount,
	});

const useClickElementCloseCancelSub = (stage: UnsubscriptionFlowStages) =>
	useSendEvent(eventsSubscriptionNames.clickElementCloseCancelSub, {
		modal_stage: stage,
	});

const useClickLinkContactSupportCancelSub = (stage: UnsubscriptionFlowStages) =>
	useSendEvent(eventsSubscriptionNames.clickLinkContactSupportCancelSub, {
		modal_stage: stage,
	});

const useClickLinkRefundPolicyCancelSub = (stage: UnsubscriptionFlowStages) =>
	useSendEvent(eventsSubscriptionNames.clickLinkRefundPolicyCancelSub, {
		modal_stage: stage,
	});

const annalsSubscription = {
	useViewModalPremiumActive,
	useClickButtonShareFeedback,
	useClickButtonSubmitFeedback,
	useClickButtonCancelRenewalFirst,
	useClickButtonKeepBenefitsCancelSub,
	useClickButtonImSureCancelSub,
	useViewModalUnsubscriptionOffer,
	useClickButtonDeclineUnsubscriptionOffer,
	useClickButtonAcceptUnsubscriptionOffer,
	useClickButtonCancelCancelSub,
	useClickButtonNotNowCancelSub,
	useViewModalCanceledPremiumCancelSub,
	useClickButtonRestoreSubscription,
	useClickElementCloseCancelSub,
	useClickLinkContactSupportCancelSub,
	useClickLinkRefundPolicyCancelSub,
};

export default annalsSubscription;
